import { render, staticRenderFns } from "./SingleText.vue?vue&type=template&id=6823f07f&scoped=true&"
import script from "./SingleText.vue?vue&type=script&lang=ts&"
export * from "./SingleText.vue?vue&type=script&lang=ts&"
import style0 from "./SingleText.vue?vue&type=style&index=0&id=6823f07f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6823f07f",
  null
  
)

export default component.exports